/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './JinkPlayerAdsContainer.css';


const JinkPlayerAdsContainer = ({ renderVideoAdElement, muted }) => (
  <div className={styles.JinkPlayerAdsContainer} data-jink-player-rewrite-container={true}>
    <video
      autoPlay={true}
      className={styles.JinkPlayerAdsContainerVideoElement}
      data-jink-player-ads-video-element={true}
      muted={!window.c2UserInteracted || muted}
      playsInline={true}
    />
    {renderVideoAdElement()}
  </div>
);

JinkPlayerAdsContainer.propTypes = {
  muted: PropTypes.bool.isRequired,
  renderVideoAdElement: PropTypes.func.isRequired,
};

export default JinkPlayerAdsContainer;
